(function(){
  var K=window.KBS||{};var ar=!!K.ar;var T=function(e,a){return ar?a:e};
  var sq=document.getElementById('kbsSearch');if(!sq)return;
  var inp=sq.querySelector('input'),form=sq.querySelector('form');
  var res=document.createElement('div');res.className='kbq__res';res.hidden=true;form.insertAdjacentElement('afterend',res);
  var pop=[].slice.call(sq.children).filter(function(e){return e!==form&&e!==res});
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  var t=null,seq=0;
  function show(on){res.hidden=!on;pop.forEach(function(e){e.style.display=on?'none':''})}
  function run(q){
    var my=++seq;
    var u='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(u,{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(j){
      if(my!==seq)return;
      var r=(j.resource_results)||{},p=r.results&&r.results.products||[],c=r.results&&r.results.collections||[],qs=r.results&&r.results.queries||[];
      if(!p.length&&!c.length&&!qs.length){res.innerHTML='<p class="kbq__no">'+T('No results for ','لا نتائج لـ ')+'"'+esc(q)+'"</p>';show(true);return}
      var h='';
      if(c.length)h+='<div class="kbq__ch">'+c.slice(0,4).map(function(x){return '<a href="'+esc(x.url)+'">'+esc(x.title)+'</a>'}).join('')+'</div>';
      if(qs.length)h+='<div class="kbq__ch kbq__q">'+qs.slice(0,4).map(function(x){return '<a href="/search?q='+encodeURIComponent(x.text)+'">'+(x.styled_text||esc(x.text))+'</a>'}).join('')+'</div>';
      h+=p.map(function(x){
        var im=x.featured_image&&x.featured_image.url?x.featured_image.url+(x.featured_image.url.indexOf('?')>-1?'&':'?')+'width=140':'';
        return '<a class="kbq__p" href="'+esc(x.url)+'"><span class="kbq__i">'+(im?'<img src="'+esc(im)+'" alt="">':'')+'</span><span><small>'+esc(x.vendor||'')+'</small><b>'+esc(x.title)+'</b><em>'+esc(parseFloat(x.price).toFixed(2))+' '+esc(K.cur||'')+'</em></span></a>';
      }).join('');
      h+='<a class="kbq__all" href="/search?q='+encodeURIComponent(q)+'">'+T('See all results','عرض كل النتائج')+'</a>';
      res.innerHTML=h;show(true);
    }).catch(function(){});
  }
  inp.addEventListener('input',function(){
    clearTimeout(t);var q=inp.value.trim();
    if(q.length<2){seq++;show(false);return}
    t=setTimeout(function(){run(q)},180);
  });
})();